<script setup lang="ts">
type Root = {
  totals: {
    total: {
      type: string;
      label: string;
      amount: string;
      value: string;
    };
    total_paid: {
      type: string;
      label: string;
      amount: string;
      value: string;
    };
    total_including_tax: {
      type: string;
      label: string;
      amount: string;
      value: string;
    };
    total_excluding_tax: {
      type: string;
      label: string;
      amount: string;
      value: string;
    };
  };
  id_address_invoice: number;
  id_address_delivery: number;
  subtotals: {
    products: {
      type: string;
      label: string;
      amount: string;
      value: string;
    };
    discounts: {
      type: string;
      label: any;
      amount: any;
      value: string;
    };
    shipping: {
      type: string;
      label: string;
      amount: string;
      value: string;
    };
    tax: {
      type: string;
      label: string;
      amount: number;
      value: string;
    };
    gift_wrapping: {
      type: string;
      label: any;
      amount: any;
      value: string;
    };
  };
  products_count: number;
  shipping: Array<{
    id_order_invoice: number;
    weight: string;
    shipping_cost_tax_excl: string;
    shipping_cost_tax_incl: string;
    url: string;
    id_carrier: number;
    carrier_name: string;
    date_add: string;
    type: string;
    can_edit: string;
    tracking_number: string;
    id_order_carrier: number;
    order_state_name: string;
    state_name: string;
    shipping_date: string;
    shipping_weight: string;
    shipping_cost: string;
    tracking: string;
  }>;
  products: {
    '91287': {
      id_product: number;
      id_supplier: number;
      id_manufacturer: number;
      id_category_default: number;
      id_shop_default: number;
      id_tax_rules_group: number;
      on_sale: number;
      online_only: number;
      ean13: string;
      isbn: string;
      upc: string;
      mpn: string;
      ecotax: string;
      quantity: number;
      minimal_quantity: number;
      low_stock_threshold: number;
      low_stock_alert: number;
      price: string;
      wholesale_price: string;
      unity: string;
      unit_price: string;
      unit_price_ratio: string;
      additional_shipping_cost: string;
      reference: string;
      supplier_reference: string;
      location: string;
      width: string;
      height: string;
      depth: string;
      weight: string;
      out_of_stock: number;
      additional_delivery_times: number;
      quantity_discount: number;
      customizable: number;
      uploadable_files: number;
      text_fields: number;
      active: number;
      redirect_type: string;
      id_type_redirected: number;
      available_for_order: number;
      available_date: string;
      show_condition: number;
      condition: string;
      show_price: number;
      indexed: number;
      visibility: string;
      cache_is_pack: number;
      cache_has_attachments: number;
      is_virtual: number;
      cache_default_attribute: number;
      date_add: string;
      date_upd: string;
      advanced_stock_management: number;
      pack_stock_type: number;
      state: number;
      product_type: string;
      id_shop: number;
      id_order_detail: number;
      id_order: number;
      id_order_invoice: number;
      id_warehouse: number;
      product_id: number;
      product_attribute_id: number;
      id_customization: number;
      product_name: string;
      product_quantity: number;
      product_quantity_in_stock: number;
      product_quantity_refunded: number;
      product_quantity_return: number;
      product_quantity_reinjected: number;
      product_price: number;
      reduction_percent: string;
      reduction_amount: string;
      reduction_amount_tax_incl: string;
      reduction_amount_tax_excl: string;
      group_reduction: string;
      product_quantity_discount: string;
      product_ean13: string;
      product_isbn: string;
      product_upc: string;
      product_mpn: string;
      product_reference: string;
      product_supplier_reference: string;
      product_weight: string;
      tax_computation_method: number;
      tax_name: string;
      tax_rate: number;
      ecotax_tax_rate: string;
      discount_quantity_applied: number;
      download_hash: string;
      download_nb: number;
      download_deadline: string;
      total_price_tax_incl: string;
      total_price_tax_excl: string;
      unit_price_tax_incl: string;
      unit_price_tax_excl: string;
      total_shipping_price_tax_incl: string;
      total_shipping_price_tax_excl: string;
      purchase_supplier_price: string;
      original_product_price: string;
      original_wholesale_price: string;
      total_refunded_tax_excl: string;
      total_refunded_tax_incl: string;
      image: {
        id: number;
        id_shop_list: Array<any>;
        image_format: string;
        force_id: boolean;
        id_image: number;
        id_product: number;
        position: number;
        cover: number;
        legend: {
          '1': string;
          '2': string;
          '4': string;
          '7': string;
          '8': string;
        };
        source_index: string;
      };
      image_size: any;
      current_stock: number;
      reduction_type: string;
      reduction_applies: number;
      tax_calculator: {
        taxes: Array<{
          id: number;
          id_shop_list: Array<any>;
          force_id: boolean;
          name: {
            '1': string;
            '2': string;
            '4': string;
            '7': string;
            '8': string;
          };
          rate: string;
          active: number;
          deleted: number;
        }>;
        computation_method: number;
      };
      product_price_wt: number;
      product_price_wt_but_ecotax: number;
      total_wt: string;
      total_price: string;
      customizedDatas: any;
      customizationQuantityTotal: number;
      id_address_delivery: number;
      name: string;
      id_product_attribute: number;
      total: string;
      attributes: Array<any>;
      cover: {
        cover: number;
        id_image: number;
        legend: string;
        position: number;
        bySize: {
          small_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          cart_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          home_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          medium_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          large_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
        };
        small: {
          url: string;
          width: number;
          height: number;
          sources: {
            jpg: string;
          };
        };
        medium: {
          url: string;
          width: number;
          height: number;
          sources: {
            jpg: string;
          };
        };
        large: {
          url: string;
          width: number;
          height: number;
          sources: {
            jpg: string;
          };
        };
        associatedVariants: Array<any>;
      };
      default_image: {
        cover: number;
        id_image: number;
        legend: string;
        position: number;
        bySize: {
          small_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          cart_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          home_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          medium_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
          large_default: {
            url: string;
            width: number;
            height: number;
            sources: {
              jpg: string;
            };
          };
        };
        small: {
          url: string;
          width: number;
          height: number;
          sources: {
            jpg: string;
          };
        };
        medium: {
          url: string;
          width: number;
          height: number;
          sources: {
            jpg: string;
          };
        };
        large: {
          url: string;
          width: number;
          height: number;
          sources: {
            jpg: string;
          };
        };
        associatedVariants: Array<any>;
      };
      unit_price_full: string;
      qty_returned: string;
      customizations: Array<any>;
    };
  };
  amounts: {
    subtotals: {
      products: {
        type: string;
        label: string;
        amount: string;
        value: string;
      };
      discounts: {
        type: string;
        label: any;
        amount: any;
        value: string;
      };
      shipping: {
        type: string;
        label: string;
        amount: string;
        value: string;
      };
      tax: {
        type: string;
        label: string;
        amount: number;
        value: string;
      };
      gift_wrapping: {
        type: string;
        label: any;
        amount: any;
        value: string;
      };
    };
    totals: {
      total: {
        type: string;
        label: string;
        amount: string;
        value: string;
      };
      total_paid: {
        type: string;
        label: string;
        amount: string;
        value: string;
      };
      total_including_tax: {
        type: string;
        label: string;
        amount: string;
        value: string;
      };
      total_excluding_tax: {
        type: string;
        label: string;
        amount: string;
        value: string;
      };
    };
  };
  details: {
    id: number;
    reference: string;
    order_date: string;
    details_url: string;
    reorder_url: string;
    invoice_url: string;
    gift_message: string;
    is_returnable: number;
    payment: string;
    module: string;
    recyclable: boolean;
    is_valid: string;
    is_virtual: boolean;
    shipping: Array<{
      id_order_invoice: number;
      weight: string;
      shipping_cost_tax_excl: string;
      shipping_cost_tax_incl: string;
      url: string;
      id_carrier: number;
      carrier_name: string;
      date_add: string;
      type: string;
      can_edit: string;
      tracking_number: string;
      id_order_carrier: number;
      order_state_name: string;
      state_name: string;
      shipping_date: string;
      shipping_weight: string;
      shipping_cost: string;
      tracking: string;
    }>;
  };
  history: {
    '1': {
      id_order_state: number;
      invoice: number;
      send_email: number;
      module_name: string;
      color: string;
      unremovable: number;
      hidden: number;
      logable: number;
      delivery: number;
      shipped: number;
      paid: number;
      pdf_invoice: number;
      pdf_delivery: number;
      deleted: number;
      id_order_history: number;
      id_employee: number;
      id_order: number;
      date_add: string;
      employee_firstname: any;
      employee_lastname: any;
      ostate_name: string;
      history_date: string;
      contrast: string;
    };
    '2': {
      id_order_state: number;
      invoice: number;
      send_email: number;
      module_name: string;
      color: string;
      unremovable: number;
      hidden: number;
      logable: number;
      delivery: number;
      shipped: number;
      paid: number;
      pdf_invoice: number;
      pdf_delivery: number;
      deleted: number;
      id_order_history: number;
      id_employee: number;
      id_order: number;
      date_add: string;
      employee_firstname: any;
      employee_lastname: any;
      ostate_name: string;
      history_date: string;
      contrast: string;
    };
    current: {
      id_order_state: number;
      invoice: number;
      send_email: number;
      module_name: string;
      color: string;
      unremovable: number;
      hidden: number;
      logable: number;
      delivery: number;
      shipped: number;
      paid: number;
      pdf_invoice: number;
      pdf_delivery: number;
      deleted: number;
      id_order_history: number;
      id_employee: number;
      id_order: number;
      date_add: string;
      employee_firstname: string;
      employee_lastname: string;
      ostate_name: string;
      history_date: string;
      contrast: string;
    };
  };
  messages: Array<any>;
  carrier: {
    id_reference: number;
    name: string;
    active: string;
    is_free: string;
    url: string;
    shipping_handling: string;
    shipping_external: string;
    range_behavior: string;
    shipping_method: number;
    max_width: number;
    max_height: number;
    max_depth: number;
    max_weight: string;
    grade: number;
    external_module_name: string;
    is_module: string;
    need_range: string;
    position: number;
    deleted: string;
    delay: string;
    id: number;
  };
  addresses: {
    delivery: {
      id_customer: number;
      id_manufacturer: number;
      id_supplier: number;
      id_warehouse: number;
      id_country: number;
      id_state: number;
      alias: string;
      company: string;
      lastname: string;
      firstname: string;
      vat_number: string;
      address1: string;
      address2: string;
      postcode: string;
      city: string;
      other: string;
      phone: string;
      phone_mobile: string;
      dni: string;
      deleted: string;
      date_add: string;
      date_upd: string;
      id: number;
      formatted: string;
    };
    invoice: {
      id_customer: number;
      id_manufacturer: number;
      id_supplier: number;
      id_warehouse: number;
      id_country: number;
      id_state: number;
      alias: string;
      company: string;
      lastname: string;
      firstname: string;
      vat_number: string;
      address1: string;
      address2: string;
      postcode: string;
      city: string;
      other: string;
      phone: string;
      phone_mobile: string;
      dni: string;
      deleted: number;
      date_add: string;
      date_upd: string;
      id: number;
      formatted: string;
    };
  };
  follow_up: string;
  labels: {
    tax_short: string;
    tax_long: string;
  };
  selected_pudo?: {
    ID: string;
    name: string;
    businessDays: Array<{
      day: number;
      dayName: string;
      dayNameIT: string;
      businessHours: Array<{
        open: string;
        close: string;
      }>;
    }>;
    telephone: any;
    street: string;
    postCode: string;
    city: string;
    province: string;
    country: string;
    coordinates: {
      latitude: number;
      longitude: number;
    };
    distance: number;
    notes: string;
    availableServices: Array<{
      serviceDescription: string;
    }>;
    holidays: Array<any>;
    type: string;
    carrier: string;
    distanceFormatted: string;
    addressFormatted: string;
    openingTimesFormatted: string;
  };
};

defineProps<{
  order: Root;
}>();
</script>
<template>
  <div class="mt-12">
    <p class="mt-2 text-xl mb-4 font-bold tracking-tight text-gray-900">
      {{ $t('History') }}
    </p>
    <div class="border-t border-b">
      <dl class="divide-y divide-gray-100">
        <div class="p-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" v-for="history in order.history" :key="history.id_order_history">
          <dt class="text-sm font-medium leading-6 text-gray-900">
            {{ history.history_date }}
          </dt>
          <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
            {{ history.ostate_name }}
          </dd>
        </div>
      </dl>
    </div>
  </div>

  <div class="mt-12">
    <p class="mt-2 text-xl mb-4 font-bold tracking-tight text-gray-900">
      {{ $t('Summary') }}
    </p>
    <dl class="space-y-4 border-t border-gray-200 py-4 text-sm font-medium text-gray-500" v-if="order">
      <div class="flex justify-between">
        <dt>{{ $t('Reference') }}</dt>
        <dd class="text-gray-900">
          {{ order.details.reference }}
        </dd>
      </div>
    </dl>
    <ul role="list" class="divide-y divide-gray-200 border-t border-gray-200 text-sm font-medium text-gray-500">
      <li v-for="product in order.products" :key="product.id_product" class="flex space-x-6 py-4">
        <NuxtImg
          :src="product.cover.medium.url"
          format="webp"
          :alt="product.name"
          class="h-24 w-24 flex-none rounded-md bg-gray-100 object-cover object-center"
          loading="lazy"
        />
        <div class="flex-auto space-y-1">
          <h4 class="text-gray-900">
            {{ product.name }}
          </h4>
        </div>
        <p class="flex-none font-medium text-gray-900">
          {{ product.total }}
        </p>
      </li>
    </ul>
    <dl class="space-y-4 border-t border-gray-200 pt-4 text-sm font-medium text-gray-500" v-if="order">
      <div class="flex justify-between">
        <dt>{{ $t('Subtotal') }}</dt>
        <dd class="text-gray-900">
          {{ order.subtotals.products.value }}
        </dd>
      </div>

      <div class="flex justify-between">
        <dt>{{ $t('Shipping') }}</dt>
        <dd class="text-gray-900">
          {{ order.subtotals.shipping.value }}
        </dd>
      </div>

      <div class="flex justify-between">
        <dt>{{ $t('Taxes') }}</dt>
        <dd class="text-gray-900">
          {{ order.subtotals.tax.value }}
        </dd>
      </div>

      <div class="flex items-center justify-between border-t border-gray-200 pt-6 text-gray-900">
        <dt class="text-base">
          {{ $t('Total (Tax Inc.)') }}
        </dt>
        <dd class="text-base">
          {{ order.totals.total.value }}
        </dd>
      </div>
    </dl>
  </div>

  <div class="grid grid-cols-1 gap-4" v-if="order">
    <h4 class="sr-only">Addresses</h4>
    <dl class="grid grid-cols-2 gap-x-6 py-8 text-sm">
      <div>
        <dt class="font-bold text-gray-900 text-lg">Shipping address</dt>
        <dd class="mt-2 text-gray-700">
          <address class="not-italic" v-html="order.addresses.delivery.formatted"></address>
        </dd>
      </div>
      <div>
        <dt class="font-bold text-gray-900 text-lg">Billing address</dt>
        <dd class="mt-2 text-gray-700">
          <address class="not-italic" v-html="order.addresses.invoice.formatted"></address>
        </dd>
      </div>
    </dl>

    <h4 class="sr-only">Payment</h4>
    <dl class="grid grid-cols-2 gap-x-6 border-t border-gray-200 py-8 text-sm">
      <div>
        <dt class="font-bold text-gray-900 text-lg">Payment method</dt>
        <dd class="mt-2 text-gray-700">
          {{ order.details.payment }}
        </dd>
      </div>
      <div>
        <dt class="font-bold text-gray-900 text-lg">Shipping method</dt>
        <dd class="mt-2 text-gray-700">
          <p class="font-semibold mb-2">{{ order.carrier.name }}</p>
          <p
            class="font-medium mb-2 uppercase font-mono"
            v-if="order.shipping && order.shipping.length > 0 && order.shipping[0]?.tracking_number"
          >
            {{ order.shipping[0]?.tracking_number }}
          </p>
          <div v-if="order.selected_pudo" class="prose-sm">
            <p v-html="order.selected_pudo.addressFormatted"></p>
            <p v-html="order.selected_pudo.openingTimesFormatted"></p>
          </div>
        </dd>
      </div>
    </dl>
  </div>
</template>
